module.exports = __webpack_public_path__ + "img/header_app_banner_kitkitschool-2.17ad2585.png";